import request from '@/utils/request';

// 获取指定用户的所有授权有效非分享店铺列表
export function getAllMallsOfUserApi(data) {
  return request({
    url: '/ecom/quicksettlement/getAllMallsOfUser',
    method: 'post',
    data
  });
}
// 获取图形验证码
export function getImageVerifyCodeByQuicksettlementApi(data) {
  return request({
    url: '/ecom/quicksettlement/getImageVerifyCode?authCode='+data,
    method: 'post',
  });
}

// 获取支付宝支付账号的完整真实姓名
export function getFillAlipayNameByQuicksettlementApi(data) {
  return request({
    url: '/ecom/quicksettlement/getFillAlipayName',
    method: 'post',
    data
  });
}

// 设置支付宝账号
export function setAliPayAccountByQuicksettlementApi(data) {
  return request({
    url: '/ecom/quicksettlement/setAliPayAccount?mallIds='+data,
    method: 'post',
  });
}
// 更新支付宝账号
export function updateAliPayAccountByQuicksettlementApi(data) {
  return request({
    url: '/ecom/quicksettlement/updateAliPayAccount?mallIds='+data,
    method: 'post',
  });
}
// 初始化解绑支付宝账号
export function initUnbindAliPayAccountByQuicksettlementApi(data) {
  return request({
    url: '/ecom/quicksettlement/initUnbindAliPayAccount?mallIds='+data,
    method: 'post',
  });
}
// 解绑支付宝账号
export function unbindAliPayAccountByQuicksettlementApi(data) {
  return request({
    url: '/ecom/quicksettlement/unbindAliPayAccount?authCode='+data,
    method: 'post',
  });
}

// 获取短信验证码
export function getSmsCodeByQuicksettlementApi(data) {
  return request({
    url: '/ecom/quicksettlement/getSmsCode?imageVerifyCode='+data,
    method: 'post',
  });
}
// 校验短信验证码
export function verifySmsCodeByQuicksettlementApi(data) {
  return request({
    url: '/ecom/quicksettlement/verifySmsCode?smsCode='+data,
    method: 'post',
  });
}

// 完成支付宝授权并写入店铺表
export function alipayAuthToUpdateMallByQuicksettlementApi(data) {
  return request({
    url: '/ecom/quicksettlement/alipayAuthToUpdateMall'+data,
    method: 'post',
  });
}
// 初始化申请人工解绑支付宝账号
export function initApplyUnbindAliPayAccountByQuicksettlementApi(data) {
  return request({
    url: '/ecom/quicksettlement/initApplyUnbindAliPayAccount?authCode='+data,
    method: 'post',
  });
}
// 申请人工解绑支付宝账号
export function applyUnbindAliPayAccountByQuicksettlementApi(data) {
  return request({
    url: '/ecom/quicksettlement/applyUnbindAliPayAccount',
    method: 'post',
    data
  });
}
// 图片上传
export function uploadFileBycustomerFastDfsApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/customerFastDfs/uploadFile',
    method: 'post',
    data
  });
}